import { AutoCheck } from 'types/auto-checks'

export const getCheckByType = (autoCheckResults: AutoCheck[], type: string) => {
  if (!autoCheckResults || !autoCheckResults.length) {
    return null
  }

  return autoCheckResults[0].checks.filter((check: any) => check.type === type)[0] || null
}
